module.exports = __webpack_public_path__ + "static/adminheropro-569ee8f26435d8459166dc1b164eb2f4.png";